import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommentsService, SnackPayload } from './service/comments.service';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router  } from '@angular/router';
import { filter } from 'rxjs';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})

export class AppComponent {
  title = 'na-web';
  showProgress = false

  constructor(
    private snackBar: MatSnackBar,
    private comments: CommentsService, 
    private translate: TranslateService,
    private router: Router
    ){
    const browserLang = this.translate.getBrowserLang() ?? 'en';
    this.translate.use(browserLang.match(/en|de/) ? browserLang : 'en');
  }

  ngOnInit(){
    this.comments.addSnackBar.subscribe((payload: SnackPayload) => this.openSnackBar(payload));

    this.comments.progressSpin.subscribe((bool) => {
      setTimeout(() => { this.showProgress = bool; });
    });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(); // (optional) actually subscribe
  }

  openSnackBar(payload: SnackPayload) {
    const { message, action, duration, panelClass } =
      typeof payload === 'string'
        ? { message: payload, action: 'OK', duration: 2000, panelClass: ['snackBarStyle'] }
        : {
            message: payload.message ?? 'Error',
            action: payload.action ?? 'OK',
            duration: payload.duration ?? 2000,
            panelClass: payload.panelClass ?? ['snackBarStyle'],
          };

    this.comments.progressSpin.emit(false);
    this.snackBar.open(message, action, {
      duration,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      panelClass,
    });
  }
}
